/*
 * Route head metadata, as DATA — deliberately its own module with no React
 * import, so the build can read it too.
 *
 * The reason this is not just a const inside route-meta.jsx: applying metadata
 * from a React effect only reaches clients that execute JavaScript. Every
 * social crawler — Facebook, Twitter/X, LinkedIn, Slack, iMessage — reads the
 * raw HTML and stops. So the component alone cannot fix a shared card, which is
 * half of what the acquisition page is for. scripts/prerender-routes.mjs bakes
 * these same values into per-route HTML at build time, and it must not be able
 * to drift from what the component applies.
 */

// Allow-list of EXACT pathnames that may be indexed. The QLearn app is the
// CONVERSION surface, not the SEO surface (that is medlearnity.com/qlearn/);
// everything authed or app-internal emits robots=noindex.
export const INDEXABLE_PATHS = ["/", "/login", "/daily-absite-question"];

// CRA substitutes the process environment at build time. Keep this exact,
// explicit opt-in shared by runtime consumers; every other value is dark.
export const isDailyAbsiteEnabled = () => (
  process.env.REACT_APP_DAILY_ABSITE_ENABLED === "true"
);

// Only routes listed here override the app-shell tags in public/index.html.
// Keep descriptions under ~155 chars — past that Google truncates mid-sentence.
export const ROUTE_META = {
  "/daily-absite-question": {
    "title": "Today's ABSITE Practice Question | QLearn by Medlearnity",
    "description":
      "Answer today's free board-style ABSITE question, see immediate feedback, and sign in for the full rationale. Built for general surgery residents.",
    "canonical": "https://qlearn.medlearnity.com/daily-absite-question"
  }
};
